/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to update an existing note
 * @export
 * @interface UpdateNoteCommand
 */
export interface UpdateNoteCommand {
    /**
     * Title of the note
     * @type {string}
     * @memberof UpdateNoteCommand
     */
    title: string;
    /**
     * Content/body of the note
     * @type {string}
     * @memberof UpdateNoteCommand
     */
    content?: string | null;
    /**
     * Due date — date CALENDAIRE ("yyyy-MM-dd" en envoi, ISO sans Z en lecture), jamais de conversion de fuseau
     * @type {string}
     * @memberof UpdateNoteCommand
     */
    dueDate?: string | null;
    /**
     * Priority referential ID
     * @type {string}
     * @memberof UpdateNoteCommand
     */
    priorityId: string;
    /**
     * Status referential ID
     * @type {string}
     * @memberof UpdateNoteCommand
     */
    statusId: string;
    /**
     * Risk ID to link this note to
     * @type {string}
     * @memberof UpdateNoteCommand
     */
    riskId?: string | null;
    /**
     * Person ID to link this note to
     * @type {string}
     * @memberof UpdateNoteCommand
     */
    personId?: string | null;
    /**
     * List of tag IDs to associate with the note (replaces existing)
     * @type {Array<string>}
     * @memberof UpdateNoteCommand
     */
    tagIds?: Array<string>;
    /**
     * List of person IDs to mention in the note (replaces existing)
     * @type {Array<string>}
     * @memberof UpdateNoteCommand
     */
    mentionPersonIds?: Array<string>;
    /**
     * List of attachment file IDs (replaces existing)
     * @type {Array<string>}
     * @memberof UpdateNoteCommand
     */
    attachmentIds?: Array<string>;
}

/**
 * Check if a given object implements the UpdateNoteCommand interface.
 */
export function instanceOfUpdateNoteCommand(value: object): value is UpdateNoteCommand {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('priorityId' in value) || value['priorityId'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    return true;
}

export function UpdateNoteCommandFromJSON(json: any): UpdateNoteCommand {
    return UpdateNoteCommandFromJSONTyped(json, false);
}

export function UpdateNoteCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNoteCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'dueDate': json['dueDate'] == null ? undefined : json['dueDate'],
        'priorityId': json['priorityId'],
        'statusId': json['statusId'],
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'personId': json['personId'] == null ? undefined : json['personId'],
        'tagIds': json['tagIds'] == null ? undefined : json['tagIds'],
        'mentionPersonIds': json['mentionPersonIds'] == null ? undefined : json['mentionPersonIds'],
        'attachmentIds': json['attachmentIds'] == null ? undefined : json['attachmentIds'],
    };
}

export function UpdateNoteCommandToJSON(json: any): UpdateNoteCommand {
    return UpdateNoteCommandToJSONTyped(json, false);
}

export function UpdateNoteCommandToJSONTyped(value?: UpdateNoteCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'content': value['content'],
        'dueDate': value['dueDate'],
        'priorityId': value['priorityId'],
        'statusId': value['statusId'],
        'riskId': value['riskId'],
        'personId': value['personId'],
        'tagIds': value['tagIds'],
        'mentionPersonIds': value['mentionPersonIds'],
        'attachmentIds': value['attachmentIds'],
    };
}

